import { fireStore } from '../firebase';

export const getDocs = async () => {
  let docRef = fireStore.collection('freqs');
  
  docRef = docRef.orderBy('index', 'asc');

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const updateDoc = async ({key, data}) => {
  return await fireStore.collection('freqs').doc(key).update(data);
}
